import React from 'react';

import { ISelectedItemType } from 'common/components/CardNav/types';

import classNames from 'classnames';
import styles from './styles.module.scss';

interface IFulfilledBodyProps {
  selectedItem: ISelectedItemType,
  defaultImage: string,
  onClick?: () => void,
  isWideImage?: boolean,
  isMirroredItem?: boolean,
}

const FulfilledBody = ({
  selectedItem: { image, title },
  defaultImage,
  onClick,
  isWideImage,
  isMirroredItem,
}: IFulfilledBodyProps) => (
  <>
    {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
    <div
      className={classNames(styles.image, {
        [styles.wideImage]: isWideImage,
      })}
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : undefined }}
    >
      <img
        src={image || defaultImage}
        alt={title}
        role="presentation"
        className={classNames({
          [styles.mirrored]: isMirroredItem,
        })}
      />
    </div>
    <div className={styles.title}>{title}</div>
  </>
);

export default FulfilledBody;
